var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filing",class:{ 'filing-mobile': _vm.isMobile }},[_vm._v(" © Copyright "+_vm._s(new Date().getFullYear())+" ke.com | 津ICP备18000836号 ")])}
var staticRenderFns = []

export { render, staticRenderFns }